export const formatDate = (date) => {
    const formattedDate = date.split("T")[0].split("-");
    return `${formattedDate[2]}-${formattedDate[1]}-${formattedDate[0]}`
};
